import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { BookOpen, GamepadIcon, CheckCircle } from "lucide-react";

type LearningJourneyWidgetProps = {
  className?: string;
};

const LearningJourneyWidget = ({ className = "" }: LearningJourneyWidgetProps) => {
  const { t } = useTranslation();

  // Mock data - Trong thực tế sẽ lấy từ API hoặc state
  const learningProgress = [
    { topic: "Tứ Diệu Đế", progress: 65 },
    { topic: "Bát Chánh Đạo", progress: 42 },
    { topic: "Ngũ Giới", progress: 78 },
  ];

  const recommendations = [
    { 
      id: 1, 
      type: "lesson", 
      title: "Trung Đạo", 
      icon: <BookOpen className="h-4 w-4 text-amber-300" /> 
    },
    { 
      id: 2, 
      type: "game", 
      title: "Quiz Ngũ Giới", 
      icon: <GamepadIcon className="h-4 w-4 text-amber-300" /> 
    },
  ];

  return (
    <div className={`bg-amber-900 text-white rounded-xl ${className}`}>
      <div className="p-6 sm:p-8">
        <h3 className="text-xl font-bold mb-6">Hành trình học tập của bạn</h3>
        
        <div className="space-y-6">
          {learningProgress.map((item, index) => (
            <div key={index} className="mb-6">
              <div className="flex justify-between mb-2">
                <span>{item.topic}</span>
                <span>{item.progress}%</span>
              </div>
              <div className="w-full bg-amber-950 bg-opacity-50 rounded-full h-2">
                <div 
                  className="bg-amber-300 h-2 rounded-full transition-all duration-700" 
                  style={{ width: `${item.progress}%` }}
                ></div>
              </div>
            </div>
          ))}
          
          <div className="bg-white bg-opacity-10 p-4 rounded-lg mt-6">
            <h4 className="font-bold mb-3">Đề xuất tiếp theo</h4>
            {recommendations.map((item) => (
              <div key={item.id} className="flex items-center mb-3 last:mb-0">
                <div className="mr-3">
                  {item.icon}
                </div>
                <p className="text-sm">{item.title}</p>
              </div>
            ))}
          </div>

          <div className="mt-4 space-y-3">
            <Button asChild variant="outline" className="w-full border-amber-300 text-amber-100 hover:bg-amber-800">
              <Link to="/learning-dashboard">Xem đầy đủ tiến độ</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearningJourneyWidget; 